export default {
  "box-name": "",
  "public-btn-text1": "即刻交易",
  "public-btn-text2": "查看點差和全部產品",
  screen0: {
    title: "CFD互換率/股息",
    desc: "請注意：CFD股息收取會在您的MT4帳戶上的餘額裏以存款或者取款形式反映出來，注釋為“Dividend”",
  },
  screen1: {
    title: "安全交易",
  },
  screen2: {
    title: "金融世界 觸手可及",
  },
  股息调整: "股息調整",
  了解您在股票和指数差价合约交易中的股息调整和分配机制:
    "了解您在指數、ETF與股票差價合約交易中的股息調整與配發機制",
  了解指数差价合约: "了解指數差價合約",
  了解股票差价合约: "了解股票差價合約",
  股息是上市公司从利润或保留资金中定期分配给股东的资金:
    "股息是上市公司或ETF基金向投資人定期配發的收益，涉及股票、指數及ETF差價合約時，系統將根據實際配息情況對持倉帳戶進行相應的現金股息調整。",
  除息日与交易优化: "除息日與交易優化",
  指数差价合约的除息日由指数提供商根据成分股设定:
    "除息日由指數提供商或ETF、股票公告決定，系統將在當天對多頭帳戶發放現金股利，對空頭帳戶扣除相應金額，提前關注除息安排有助於優化部位與收益管理。",
  股息调整明细: "股息調整明細",
  差价合约交易中相关产品的股息数据:
    "差價合約交易中相關產品的股息數據，以多頭（買入）股息和空頭（賣出）股息分開顯示",
  交易产品: "Trading Products",
  多头股息: "Long Dividends",
  空头股息: "Short Dividends",
  除息日: "Ex-dividend Dates",
  即刻交易: "即時交易",
  股息的常见问题: "股息的常見問題",
  qaList: [
    {
      q: "1、什麼是股息和除息日？",
      a: [
        "股息是上市公司或ETF基金從獲利或資產中配發給投資人的資金。除息日是該資產正式配息並調整價格的日期，通常在當天開盤前調整淨值或報價。",
        "在差價合約產品中，無論是指數、ETF 還是股票類CFD，除息行為都會導致價格調整，因此系統將對持倉客戶進行現金補償或扣款作業。",
      ],
    },
    {
      q: "2. 股息調整的時間",
      a: [
        "指數差價合約股利調整通常會在除息日的00:00-01:00（MT 時間）反映在您的MT4/MT5交易帳號中，並標註為「Dividend」。",
        "股票及ETF差價合約股利調整通常會在除息日的16:30（MT 時間）前反映在您的MT5交易帳號中，並標註為「Dividend」。"
      ],
    },
    {
      q: "3. 股息對指數交易的影響",
      a: [
        "持有多頭部位（買入）：股利調整將存入您的MT4/MT5帳號。",
        "持有空頭部位（賣出）：股利調整將從您的MT4/MT5帳號扣除。",
        "請注意：ETF產品的股息調整也遵循相同原則，依據基金公司公告的派息數據進行調整。"
      ],
    },
    {
      q: "4. 股息調整的計算公式",
      a: [
        "多頭部位（買入）計算公式：手數 × 合約規格 × 多頭股息金額（以指數計價貨幣計算）",
        "空頭部位（賣出）計算公式：手數 × 合約規格 × 空頭股息金額（以指數計價貨幣計算）",
      ],
    },
    {
      q: "5. 股息調整計算範例",
      a: [
        "以SPXUSD為例，假設其除息日為2024年10月11日，多頭股息金額為 0.050美元，空頭股息金額為-0.050美元。如果您在除息日前一天(10月10日)收盤時持有1標準手的SPXUSD多頭部位（買入），則股息調整的計算如下：",

        "股息調整 = 1（標準手） × 100（合約規格） × 0.050美元（多頭股息金額） = 5美元",
        "在除息日的00:00-01:00（MT時間），5美元將存入您的MT4/MT5帳號，備註為「Dividend」。",

        "如果您持有空頭部位（賣出），5美元將從您的MT4/MT5帳號中扣除，備註為「Dividend」。 ",
      ],
    },
    {
      q: "6. 注意事項",
      a: [
        "股息調整適用於指數、ETF 及股票類差價合約。",
        "調整金額會根據除息日的派息數據、持倉方向及交易手數自動計算與處理。 ",
        "ETF 差價合約的股息金額以對應基金官方公告為準，並可能因標的資產變動而有所波動。",
        "股息調整不會影響持倉的點差或交易成本，但會影響帳戶淨值及餘額。",
        "如需查詢特定 ETF 或指數的除息安排，建議您參閱我們的【股息調整明細】，或聯繫您的客戶經理。"
      ],
    },
  ],
};
